import type { ContentObject } from 'models';
import { useMutation } from 'query';
import { useUpdateLike } from '../../hooks';
import { unlikeObject } from '../../services';

export const useUnlikeObjectMutation = () => {
  const updateCache = useUpdateLike({ action: 'unlike' });

  return useMutation<unknown, { contentObject: ContentObject }>({
    mutationFn: async ({ contentObject }) => unlikeObject({ routeParams: { id: contentObject.id } }),
    onSuccess(_, params) {
      updateCache(params);
    },
  });
};
